export var AppActionTypes;
(function (AppActionTypes) {
    AppActionTypes["GET_FORM_DATA"] = "GET_FORM_DATA";
    AppActionTypes["GET_LAST_MINUTE_BLOCK_RESULT"] = "GET_LAST_MINUTE_BLOCK_RESULT";
    AppActionTypes["RECEIVE_TRANSLATIONS"] = "RECEIVE_TRANSLATIONS";
    AppActionTypes["SET_CURRENT_STEP"] = "SET_CURRENT_STEP";
    AppActionTypes["SET_LOCATION"] = "SET_LOCATION";
    AppActionTypes["SET_URL_CONTEXT"] = "SET_URL_CONTEXT";
    AppActionTypes["SET_URL_HOTEL_CODE"] = "SET_URL_HOTEL_CODE";
    AppActionTypes["SET_URL_PRODUCT_GROUP_ID"] = "SET_URL_PRODUCT_GROUP_ID";
    AppActionTypes["SET_URL_PRODUCT_QUERY"] = "SET_URL_PRODUCT_QUERY";
    AppActionTypes["SET_URL_PRODUCT_OPTIONS"] = "SET_URL_PRODUCT_OPTIONS";
    AppActionTypes["SET_URL_QUERY"] = "SET_URL_QUERY";
})(AppActionTypes || (AppActionTypes = {}));
